module.exports = __webpack_public_path__ + "static/favicon-cf78f645e444a718cd34ec57c09333d8.ico";